var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 13v9a1 1 0 0 1-1 1h-7V13h8zm-12 0v10H3a1 1 0 0 1-1-1v-9h8zm9.482-10.613c.864 1.346.617 2.67-.52 3.598L18.942 6H22a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3.058l-.02-.015c-1.09-.889-1.362-2.143-.623-3.43l.103-.168C5.53.808 7.077.637 8.646 1.572c.812.484 1.632 1.247 2.461 2.219.31.363.61.742.894 1.126.283-.384.582-.763.892-1.126.829-.972 1.65-1.735 2.46-2.219 1.57-.936 3.116-.764 4.13.815zM6.272 3.542c-.285.517-.254.713.1 1.047.462.44 1.332.833 2.466 1.135.4.106.817.198 1.242.276-.14-.207-.284-.411-.43-.61-.687-.934-1.348-1.65-1.929-2.052-.724-.501-1.085-.455-1.448.204zm10.007-.204c-.58.402-1.242 1.118-1.929 2.052-.146.199-.29.403-.43.61.425-.078.843-.17 1.242-.276 1.134-.302 2.004-.696 2.466-1.135.354-.334.385-.53.1-1.047-.364-.659-.725-.705-1.45-.204z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.dabcd9e5.svg";
export { ForwardRef as ReactComponent };